import { Component, OnInit } from '@angular/core';
import { GlobalService } from '@services/index';
import { CMSApiService } from '@services/api/cms-api.service';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css'],
})
export class PrivacyComponent implements OnInit {
  content: string;
  isLoading = true;

  constructor(
    private globalService: GlobalService,
    private cms: CMSApiService
  ) {}

  ngOnInit() {
    this.load();
  }

  load() {
    this.cms.getToken().subscribe((retToken) => {
      this.globalService.cmsToken = retToken.access_token;
      this.cms.getPrivacy().subscribe((ret) => {
        this.content = ret.items[0].data.value.iv;
        this.isLoading = false;
      });
    });
  }
}
